import React from "react";
import {
  Dialog,
  Button,
  DialogTitle,
  DialogActions,
  Box,
  Typography,
  DialogContent,
  DialogContentText,
  Grid,
} from "@mui/material";
import Slide from "@mui/material/Slide";
import { logEventos } from "../../../services/services";
import { UrlApi } from "../../../services/apirest";

const FacturasDelete = ({
  setOpen,
  activa,
  id,
  getFacturas,
  mostrarAlerta,
  open,
}) => {
  const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });

  const handleClick = async () => {
    try {
      const response = await fetch(`${UrlApi}/facturasParametros/${id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ activo: !activa }),
      });

      if (!response.ok) {
        throw new Error("Error en la solicitud");
      }
      mostrarAlerta(
        "La actividad de la factura se actualizo correctametne",
        "success"
      );
      await getFacturas();
    } catch (error) {
      console.error("Error al realizar la solicitud:", error);
      mostrarAlerta(
        "Hubo un problema al cambiar el estado de la factura. Intente nuevamente.",
        "error"
      );
    }

    logEventos(
      "Habilitando/Deshabilitando Factura",
      "Facturas",
      "Cambiando estado de actividad de factura",
      localStorage.getItem("user")
    );

    setOpen(false);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      TransitionComponent={Transition}
    >
      <Box justifyContent="center" backgroundColor="#1F618D">
        <DialogTitle>
          <Box component="div">
            <Typography
              variant="h6"
              align="center"
              color="#ffffff"
              sx={{ fontWeight: "bold" }}
            >
              Cambio de estado
            </Typography>
          </Box>
        </DialogTitle>
      </Box>
      <DialogContent>
        <DialogContentText textAlign={"center"}>
          ¿Esta seguro que quiere cambiar el estado de actividad de la factura?
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        <Grid
          container
          direction="row"
          justifyContent="space-around"
          alignItems="center"
        >
          <Button
            variant="contained"
            onClick={handleClose}
            style={{ backgroundColor: "#d32f2f", color: "#ffffff" }}
          >
            Volver
          </Button>
          <Button
            style={{ color: "#ffffff" }}
            type="submit"
            onClick={handleClick}
            variant="contained"
            color="primary"
          >
            Confirmar
          </Button>
        </Grid>
      </DialogActions>
    </Dialog>
  );
};

export default FacturasDelete;
